/**
 * Calendrier planning : semaine = lundi → dimanche (fuseau local).
 * `weekIndex` 0 = semaine contenant aujourd'hui ; négatif = passé ; positif = futur.
 */

function mondayOfWeekContaining(date) {
  const c = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const dow = c.getDay();
  const diff = dow === 0 ? -6 : 1 - dow;
  c.setDate(c.getDate() + diff);
  c.setHours(0, 0, 0, 0);
  return c;
}

function addDaysLocal(date, delta) {
  const out = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  out.setDate(out.getDate() + delta);
  out.setHours(0, 0, 0, 0);
  return out;
}

export function mondayForWeekOffset(offsetWeeks, refDate = new Date()) {
  const anchor = mondayOfWeekContaining(refDate);
  return addDaysLocal(anchor, offsetWeeks * 7);
}

function toIsoDateLocal(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Même règle que `weekStartSchema` côté API (lundi 00:00 UTC).
 * Évite un décalage entre les lundis « calendrier local » et les clés renvoyées par
 * `/api/planning/hidden-weeks` (icône publication toujours verte sinon).
 */
export function normalizeWeekStartIso(isoDate) {
  const d = new Date(`${isoDate}T00:00:00.000Z`);
  const day = d.getUTCDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setUTCDate(d.getUTCDate() + diff);
  d.setUTCHours(0, 0, 0, 0);
  return d.toISOString().slice(0, 10);
}

/** Lundi (AAAA-MM-JJ) pour l’API `/api/planning?week=` — aligné sur le backend. */
export function weekStartIsoForIndex(weekIndex, refDate = new Date()) {
  const localMonday = toIsoDateLocal(mondayForWeekOffset(weekIndex, refDate));
  return normalizeWeekStartIso(localMonday);
}

export function relativeCalendarWeekLabel(weekIndex) {
  if (weekIndex === 0) return "semaine actuelle";
  if (weekIndex > 0) {
    return weekIndex === 1 ? "dans 1 semaine" : `dans ${weekIndex} semaines`;
  }
  const n = Math.abs(weekIndex);
  return n === 1 ? "il y a 1 semaine" : `il y a ${n} semaines`;
}

/** Les 7 dates locales (lun → dim) pour cet offset. */
export function datesForWeekOffset(weekIndex, refDate = new Date()) {
  const mon = mondayForWeekOffset(weekIndex, refDate);
  return Array.from({ length: 7 }, (_, i) => addDaysLocal(mon, i));
}

/** ~10 ans en arrière / avant (navigation employé mode API). */
export const PLANNING_WEEK_INDEX_MIN = -520;
export const PLANNING_WEEK_INDEX_MAX = 520;

export const PLANNING_API_WEEK_INDICES = Object.freeze(
  Array.from(
    { length: PLANNING_WEEK_INDEX_MAX - PLANNING_WEEK_INDEX_MIN + 1 },
    (_, i) => i + PLANNING_WEEK_INDEX_MIN
  )
);
